import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AddCardPage from './pages/AddCardPage';
import PaymentSuccess from './pages/PaymentSuccess';
import ViewCardPage from './pages/ViewCardPage';
import CardRouter from './pages/CardRouter';
import { CardProvider } from './context/CardContext'

export default function App() {
  return (
    <CardProvider>
      <Router>
        <Routes>

          <Route path="/" element={<CardRouter />}>
            <Route path="viewcardpage" element={<ViewCardPage />} />
            <Route path="addcard" element={<AddCardPage />} />
          </Route>
          <Route path="/payment-success" element={<PaymentSuccess />} />

        </Routes>
      </Router>
    </CardProvider>
  );
}